import { render, staticRenderFns } from "./groupbuy.vue?vue&type=template&id=4137e01a&scoped=true&"
import script from "./groupbuy.vue?vue&type=script&lang=js&"
export * from "./groupbuy.vue?vue&type=script&lang=js&"
import style0 from "./groupbuy.vue?vue&type=style&index=0&id=4137e01a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4137e01a",
  null
  
)

export default component.exports